import { createApp } from 'vue';
import App from '~app/app.vue';
import { pinia } from '~app/core/store';
import router from '~app/app.routes';
import vuetify from '~app/shared/vuetify';

import { createAuthPlugin } from '~app/core/auth';
import { createConfigPlugin } from '~app/core/config';
import { useConfigStore } from '~app/core/config/store';
import { apiClient } from '~app/core/api-client';
import { createErrorPlugin } from '~app/core/error/plugin';
import { ToastPlugin } from '~app/shared/toast';

const app = createApp(App);
app.use(vuetify);
app.use(pinia);

const ErrorPlugin = createErrorPlugin({ router });
const ConfigPlugin = createConfigPlugin({ pinia, apiClient });
const AuthPlugin = createAuthPlugin({ pinia, router, apiClient });

app.use(ToastPlugin);
app.use(ErrorPlugin);
app.use(ConfigPlugin);
app.use(AuthPlugin);

export function bootstrap(elementOrSelector?: Element | string): Promise<void> {
  return useConfigStore()
    .fetch()
    .then(() => {
      app.use(router);
      return app.mount(elementOrSelector);
    })
    .then(ErrorPlugin.listen)
    .then(() => router.isReady());
}
